var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(-1438 -838)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 32,
    height: 32,
    transform: "translate(1438 838)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_211755_heart_icon",
    "data-name": "211755_heart_icon",
    d: "M68.782,82.5a5.229,5.229,0,0,1,3.783,1.6,5.229,5.229,0,0,1,3.783-1.6,5.308,5.308,0,0,1,3.67,9.117l-7.453,7.528-.841-.849-6.751-6.818a5.308,5.308,0,0,1,3.81-8.977Z",
    transform: "translate(1381.5 763.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVote);
export default __webpack_public_path__ + "static/media/icon-vote.4110c4b8de92bb869d5918ef703ba30f.svg";
export { ForwardRef as ReactComponent };